
  import { defineComponent, PropType } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { IWorkout } from '@/types/workouts'

  export default defineComponent({
    name: 'CalendarWorkout',
    props: {
      workout: {
        type: Object as PropType<IWorkout>,
        required: true,
      },
      sportLabel: {
        type: String,
        required: true,
      },
    },
    setup() {
      const { t } = useI18n()
      return { t }
    },
  })
